<template>
<label class="agreement">
    <input type="checkbox" class="d-none" :name="formName" :checked="modelValue" :value="idCode" @input="updateValue($event.target.checked)"/>
    <div class="agreement__checkbox" :class="{'error': error}"></div>
    <div class="agreement__text-wrapper">
        <span class="agreement__text">Согласен (-на) на </span>
        <template v-if="type==='modal'">
            <span class="agreement__text agreement__link-colored" :data-modal-trigger="generateModalId">получение рекламных материалов</span>
        </template>
        <template v-if="type==='link'">
            <span class="agreement__text"> обработку </span>
            <span class="agreement__text agreement__link-colored" :data-modal-trigger="generateModalId">персональных данных</span>
            <span class="agreement__text"> в&nbsp;соответствии&nbsp;с&nbsp;</span>
            <a class="agreement__text agreement__link-colored" :href="link" target="_blank">политикой</a>
        </template>
        <span class="agreement__error" v-if="error">Подтвердите согласие</span>
    </div>
</label>
<teleport to="body">
    <ui-modal :modal-id="generateModalId" custom-class="ui-modal-condition" :title="header" :preventScroll="preventScroll" @modal-open="getPersData()">
        <div v-html="content"></div>
    </ui-modal>
</teleport>

</template>

<script>
import UiModal from './ui/UiModal';

export default {
    name: 'AgreementBlock',
    components: { UiModal },
    props: {
        modelValue: {
            type: String,
            required: true
        },
        formName: {
            type: String,
            required: true,
            default: 'form[agreement_id]'
        },
        idCode: {
            type: String,
            required: true,
            default: 'z1'
        },
        type: {
            type: String,
            required: true,
            default: 'modal'
        },
        link: {
            type: String,
            default: '/upload/documents/personal_data_process.pdf'
        },
        error: {
            type: Boolean,
            default: false
        },
        preventScroll: {
            type: Boolean,
            default: true
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            header: '',
            content: 'Загрузка...'
        };
    },
    computed: {
        // Здесь можно добавить вычисляемые свойства
        // Функция для генерации уникального ID с префиксом
        generateModalId() {
            // Генерируем случайную строку из букв и цифр
            const randomString = Math.random().toString(36).substring(2, 8);
            // Собираем ID из префикса и случайных значений
            return `ui-modal-${randomString}`;
        }
    },
    methods: {
        // Здесь можно добавить методы
        showModal() {

        },
        updateValue(checked) {
            this.$emit('update:modelValue', checked)
        },
        getPersData() {
            fetch(`/api/v2/content/policy/?code=${this.idCode}`)
                .then((response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok');
                })
                .then((response) => {
                    this.content = response.data.props.text;
                    this.setClasses();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        showModal(id) {
            this.getPersProcessing(id);
        },
        setClasses() {
            const textHtml = this.content;
            const htmlObject = document.createElement('div');
            htmlObject.innerHTML = textHtml;
            htmlObject
                .querySelector('p')
                .classList.add('content-title', 'n-mb-3');
            const paragraph = htmlObject.querySelectorAll('p');
            paragraph.forEach((el) => {
                if (el.classList.contains('content-title')) {
                    return false;
                }
                el.classList.add(
                    'page-notification',
                    'page-notification_black',
                    'n-mb-2'
                );
            });
            const ulList = htmlObject.querySelectorAll('ul');
            ulList.forEach((el) => {
                el.classList.add(
                    'bullet-list',
                    'bullet-list_smaller',
                    'black-bullet',
                    'bullet-list-text',
                    'n-mb-3'
                );
            });
            const list = htmlObject.querySelectorAll('li');
            list.forEach((el) => {
                el.classList.add('bullet-list__item');
            });
            this.header = htmlObject.querySelector('.content-title').textContent;
            htmlObject.querySelector('.content-title').remove();
            this.content = htmlObject.innerHTML;
        },
    }
};
</script>